/**
 * Early redirect for unactivated-customer flows (login + register).
 * Loaded synchronously so a CAPTCHA / Shopify form re-submit does not flash
 * the login error before the activation info page.
 * Key and lifetime must match CustomerFormValidation.#storeUnactivatedRegisterRedirect.
 */
(() => {
  const KEY = 'gh-register-unactivated-redirect';
  const TIME_TO_LIVE_MS = 20_000;

  try {
    const raw = sessionStorage.getItem(KEY);
    if (!raw) return;

    sessionStorage.removeItem(KEY);

    const payload = JSON.parse(raw);
    const url = typeof payload?.url === 'string' ? payload.url.trim() : '';
    const at = Number(payload?.at);
    if (!url || !Number.isFinite(at) || Date.now() - at > TIME_TO_LIVE_MS) return;

    window.location.replace(url);
  } catch {
    // sessionStorage / parse may fail; ignore
  }
})();
